<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-05-01"></menubar>
    </div>
    <!--  左メニュー 終了 -->

    <!--   ヘッダー行の開始   -->
    <el-row slot="header">
      <headTitle class="cancel-width">
        <label slot="title">{{this.$t('label.system.setting.various.setting')}}</label>
      </headTitle>
    </el-row>

    <div slot="body">
      <el-row>
        <div class="notification-width-460">
          <span
            class="c-ivory01"
            v-show="$checkRoleFunc('0402','080100') || $checkAuthFunc('090203','090200')">
            {{this.$t('label.system.setting.various.settings')}}
          </span>
          <lvory-but
            v-auth="{ role: '0402' , funcCode: '080100' }"
            class="margin-top-40"
            @click="pointSetting"
            >
            {{this.$t('label.system.setting.various.WorkOffice')}}
          </lvory-but>
          <lvory-but
            v-auth="{ auth: '090203' , funcCode: '090200' }"
            class="margin-top-20"
            @click="deskSetting">
            {{this.$t('label.system.setting.various.helpDeskInformaiton')}}
          </lvory-but>
          <div
            class="c-ivory01 margin-top-20">
            {{ $t("label.menu.management") }}
          </div>
          <!--  オーナー  -->
          <lvory-but
            v-auth="{ auth: '010201' }"
            class="margin-top-20"
            @click="linkOwner">
            {{ $t("label.menu.ownerMenu") }}
          </lvory-but>

          <!--  ビル  -->
          <lvory-but
            v-auth="{ auth: '010301' }"
            class="margin-top-20"
            @click="linkBuilding">
            {{ $t("label.menu.buildingsMenu") }}
          </lvory-but>

          <!--  エリア  -->
          <lvory-but
            v-auth="{ auth: '010501' }"
            class="margin-top-20"
            @click="linkArea">
            {{ $t("label.menu.areaMenu") }}
          </lvory-but>

          <!--  テナント  -->
          <lvory-but
            v-auth="{ auth: '010601' }"
            class="margin-top-20"
            @click="linkTenant">
            {{ $t("label.menu.tenantMenu") }}
          </lvory-but>

          <!--  ワークスペース（指定席）  -->
          <lvory-but
            v-auth="{ auth: '040101' , func: '040100' }"
            class="margin-top-20"
            @click="linkFix">
            {{ $t("label.menu.fixDeskMenu") }}
          </lvory-but>

          <!--  会議室  -->
          <lvory-but
            v-auth="{ auth: '020101' , func: '020100' }"
            class="margin-top-20"
            @click="linkMeeting">
            {{ $t("label.menu.meetingRoomMenu") }}
          </lvory-but>

          <!--  施設（Outlook）-->
          <lvory-but
            v-auth="{ auth: '130101' , func: '130100' }"
            class="margin-top-20"
            @click="linkOutlookMeeting">
            {{ $t("label.menu.meetingRoomOutlookMenu") }}
          </lvory-but>

          <!--  アカウント  -->
          <lvory-but
            v-auth="{ auth: '010101' }"
            class="margin-top-20"
            @click="linkAccount">
            {{ $t("label.menu.zhangaccount") }}
          </lvory-but>

          <!--  アカウント  -->
          <lvory-but
            v-auth="{ auth: '010701' }"
            class="margin-top-20"
            @click="linkUserGroup">
            {{ $t("label.menu.UserGroup") }}
          </lvory-but>

          <!--  環境可視化  -->
          <lvory-but
            v-auth="{ auth: '060401', func: '060140' }"
            class="margin-top-20"
            @click="linkVisualEnv">
            環境可視化
          </lvory-but>

          <!--  サイネージ  -->
          <lvory-but
            v-auth="{ auth: '060406', func: '110100' }"
            class="margin-top-20"
            @click="linkCmsEnv">
            サイネージ
          </lvory-but>

          <!--  位置共有  -->
          <!-- func: '120100' -->
          <lvory-but
            v-auth="{ auth: '010320', func: '120100' }"
            class="margin-top-20"
            @click="toLocation">
            {{ $t("label.menu.locationSharingMenu") }}
          </lvory-but>

        </div>
        <div class="user-width-460">
          <div class="user-width-256">
            <!-- login もう一度追加 -->
            <smart-office-auth-image
              class="img-item"
              :src="iconUrl">
            </smart-office-auth-image>
            <p class="text-center user-fullName">{{ this.userInfo.fullname }}</p>
            <p class="text-center user-companyName">{{ this.userInfo.orgName }}</p>
            <!-- <p v-if="balanceFlag" class="text-center user-pointNumber">{{ $t('label.system.setting.various.nowPoint') }}</p>
            <p v-if="balanceFlag" class="text-center ">
              <span class="user-point-number font-lato">{{ balance }}</span>
              <span class="pt-style font-lato">pt</span>
            </p> -->
            <lvory-but
            class="margin-top-37 text-center"
            @click="settingAccountInfo">
            {{this.$t('label.system.setting.various.accountInformation')}}
            </lvory-but>
            <lvory-but
              v-if="!$checkSsoUser()"
              class="margin-top-16 text-center"
              @click="goSettingPassword">
              {{this.$t('label.system.setting.various.resetPassword')}}
            </lvory-but>
            <!-- logOut もう一度追加 -->
            <lvory-but
              class="margin-top-16 text-center"
              @click="logout">
              {{this.$t('label.system.setting.various.logOut')}}
            </lvory-but>
          </div>
        </div>
      </el-row>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>
    </div>
  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout"
import headTitle from "@/components/common/head/head"
import SmartOfficeAuthImage from "@/components/common/image/AuthImageUser"
import LvoryBut from "@/components/common/generalButton/LvoryBut"
import elDialogPrompt from "@/components/common/el-dialog-prompt"
import Menubar from "@/components/leftmenu/DashBoard"
import SystemManageApi from "@/api/SystemManageApi"
import errorCodeMsg from "@/utils/error-code-msg"
// import Configuration from "@/config/index";

export default {
  name:"ConciergeTop",
  components:{
    MainLayout: NewDesignLayout,
    headTitle:headTitle,
    LvoryBut:LvoryBut,
    SmartOfficeAuthImage: SmartOfficeAuthImage,
    elDialogPrompt: elDialogPrompt,
    Menubar: Menubar
  },
  data(){
    return{
      isTenantMenu: true,
      iconUrl: null,
      balance: 0,
      balanceFlag: false,
      msgParam: this.$t('message.common.logout'),
      centerDialogVisibleIsShow: false,
      userInfo: {},
      nowPoint: "807"
    }
  },
  methods:{
    isPassParam(param){
      if(param){
        this.$toLogout();
      }
    },
    goSettingPassword(){
      this.$router.push({
        name:"system-setting-password"
      })
    },

    logout() {
      this.centerDialogVisibleIsShow = true
    },
    getPointInfo() {
      SystemManageApi.getPointDetail()
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if( data.statusCode == "Success" ) {
          this.balance = data.body.balance
          if( this.$checkAuthCode('070102') ) {
            this.balanceFlag = true
          }else {
            this.balanceFlag = false
          }
        }
      })
    },
    editIcon() {
      this.$router.push({
        name:"system-account-info",
        flag: "02"
      })
    },

    linkOwner() {
      if(this.$IsOwnerUser()) {
        this.$router.push({
          name: 'system-owner-detail',
          params: {
            ownerId: this.$getOrgId()
          }
        })
      }else {
        this.$router.push({
          name:"system-owner-search",
        })
      }
    },

    linkBuilding() {
      this.$router.push({
        name:"system-building-search",
      })
    },

    linkArea() {
      this.$router.push({
        name:"system-area-search",
      })
    },

    linkTenant() {
      if(this.$IsTenantUser()) {
        this.$router.push({
          name: 'system-tenant-detail',
          params: {
            tenantId: this.$getOrgId()
          }
        })
      }else {
        this.$router.push({
          name:"system-tenant-search",
        })
      }
    },

    linkFix() {
      this.$router.push({
        name:"system-fixDesk-search",
      })
    },

    linkMeeting() {
      this.$router.push({
        name:"system-meetingRoom-search",
      })
    },

    linkOutlookMeeting() {
      this.$router.push({
        name:"system-outlookMeetingRoom-search",
      })
    },


    linkAccount() {
      this.$router.push({
        name:"system-account-search",
      })
    },

    linkUserGroup() {
      this.$router.push({
        name:"system-user-group-search",
      })
    },

    linkVisualEnv() {
      this.$router.push({
        name:"page-search",
      })
    },

    deskSetting() {
      this.$router.push({
        name:"system-setting-notification-concierge",
        query: {
          flag: "02"
        }
      })
    },

    pointSetting() {
      this.$router.push({
        name:"system-setting-notification-point",
        query: {
          flag: "01"
        }
      })
    },

    goSettingNotification(){
      this.$router.push({
        name:"system-setting-notification"
      })
    },
    settingAccountInfo(){
      this.$router.push({
        name:"system-setting-accountInfo"
      })
    },
    getLoginInfo(){
      this.userInfo = this.$getLoginInfo()
      this.iconUrl = this.$GetImageUrl(this.userInfo.portrait.url)
    },
    linkCmsEnv(){
      this.$router.push({
        name:"page-management",
      })
    },
    toLocation(){
      this.$router.push({
        name:"system-setting-location-list",
      })
    }
  },
  mounted() {
    if( this.$checkRole('0401') || this.$checkRole('0404')) {
      if( this.$checkFuncCode('070100')) {
        if( this.$checkAuthCode('070102') ) {
         this.getPointInfo()
         }
      }
    }

    if(this.$CheckRole("0401") || this.$CheckRole("0404")){
      this.isTenantMenu = false
    }
  },
  created(){
    this.$authCheck("010101")
    this.getLoginInfo()
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "",
        title: "label.router.set",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    height: 32px;
  }
}
.notification-width-460{
  width: 460px;
  float: left;
}
.user-width-460{
  width: 460px;
  max-inline-size: fit-content;
  float: left;
}
.margin-top-30{
  margin-top:30px;
  display: block;
}
.margin-top-40{
  margin-top: 40px;
}
.margin-top-37{
  margin-top: 37px;
}
.margin-top-16{
  margin-top: 16px;
}
.margin-top-20{
  margin-top: 20px;
}
::v-deep .notification-width-460{
  .my-button{
    width: 460px;
    height: 60px;
    text-align: left;
    font-size: 16px;
  }
}
.user-width-256{
  width: 256px;
  height: auto;
  // margin-top: 30px;
  padding-top: 40px;
  padding-left: 38px;
  padding-right: 30px;
  padding-bottom: 28px;
  margin-left: 84px;
  background-color: #F7F7F2;
  border-radius: 8px;
  border: 0;
  box-shadow: -2px -2px 4px #FFFFFA,
            4px 4px 4px #E6E6D8;
}
.img-item {
  border-radius: 50%;
  width: 60px;
  height: 60px;
  margin: auto;
}
.user-fullName{
  margin-top: 17px;
  font-size: 16px;
  color: #525250;
}
.user-companyName{
  font-size: 12px;
  color: #858582;
}
.user-pointNumber{
  margin-top: 16px;
  font-size: 12px;
  color: #525250;
}
.user-point-number {
  font-size: 22px;
  color: #525250;
  margin-top: 4px;
}
.pt-style {
  font-size: 16px;
  color: #525250;
}

::v-deep .auth-image-box .auth-image {
  object-fit: fill !important;
}
</style>
